import { render, staticRenderFns } from "./index.vue?vue&type=template&id=73adcca0"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=73adcca0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardProductTraditional: require('/var/www/html/fantini/frontend-2/components/card/product/traditional/index.vue').default,BtnCircle: require('/var/www/html/fantini/frontend-2/components/btn/circle/index.vue').default,BtnPill: require('/var/www/html/fantini/frontend-2/components/btn/pill/index.vue').default,GridCss: require('/var/www/html/fantini/frontend-2/components/grid/css/index.vue').default,Block: require('/var/www/html/fantini/frontend-2/components/block/index.vue').default})
